export const CREATE_DRAFT_COLLECTION = 'CREATE_DRAFT_COLLECTION';
export const GET_DRAFT_COLLECTIONS = 'GET_DRAFT_COLLECTIONS';
export const DRAFT_COLLECTION_REQUEST = 'DRAFT_COLLECTION_REQUEST';
export const UPDATE_DRAFT_COLLECTION = 'UPDATE_DRAFT_COLLECTION';
export const DELETE_DRAFT_COLLECTION = 'DELETE_DRAFT_COLLECTION';
export const DRAFT_COLLECTION_REQUEST_FAILURE = 'DRAFT_COLLECTION_REQUEST_FAILURE';
export const DRAFT_COLLECTION_REQUEST_SUCCESS = 'DRAFT_COLLECTION_REQUEST_SUCCESS';
export const GET_DRAFT_COLLECTIONS_PAGE = 'GET_DRAFT_COLLECTIONS_PAGE';
